import DefaultFactory from "/scripts/default/factory";
import PricingPlans from "/components/pricing/plans";
import PricingFaqs from "/components/pricing/faqs";
import PricingAnimation from "/components/pricing/plans/animation.js";
import AccordionRow from "/components/accordionRow";

/*
	Individual page factories follow the same principles as
	the global factory in /public/scripts/index.js but contain
	blocks that should only be checked for on a single page
*/
class PricingFactory extends DefaultFactory {
	createBlock(blockName, block) {
		switch (blockName) {
			case "pricing-plans":
				return new PricingPlans(block);
			case "pricing-animation":
				return new PricingAnimation(block);
			case "pricing-faqs":
				return new PricingFaqs(block);
			case "accordion-row":
				return new AccordionRow(block);
			default:
				return null;
		}
	}
}

new PricingFactory();
